module.exports = __webpack_public_path__ + "media/images/convenios/consej_ing_arq_agri-b762da7c76d06857e1f1b0bf8635e843.png";